import { Component, ViewChild } from '@angular/core';
import { PowerBIReportEmbedComponent } from 'powerbi-client-angular';
import { IReportEmbedConfiguration, models, service, Embed } from 'powerbi-client';
import { PowerBiService } from '../../services/powerbi.service';
import { PowerbiModalComponent } from '../powerbi-modal/powerbi-modal.component';
import { LoadManagerService } from 'src/app/common/loadingOverlay/loadManager.service';

@Component({
  selector: 'app-powerbi-dialog',
  templateUrl: './powerbi-dialog.component.html',
  styleUrl: './powerbi-dialog.component.css',
  standalone: false
})
export class PowerBiDialogComponent {

  @ViewChild(PowerbiModalComponent, { static: true }) private dialog: PowerbiModalComponent;
  @ViewChild(PowerBIReportEmbedComponent) public reportObj!: PowerBIReportEmbedComponent;

  errorPowerBi = '';

  // Clase CSS usada para la creación del wrapper del report PowerBi
  public reportClass = 'report-container';

  // Configuración inicial del report PowerBi
  public reportConfig: IReportEmbedConfiguration = {
    type: 'report',
    embedUrl: undefined,
    tokenType: models.TokenType.Embed,
    accessToken: undefined,
    settings: {
      localeSettings: {
        language: "es-ES"
      },
      navContentPaneEnabled: false,
      panes: {
        filters: {
          expanded: false,
          visible: false
        },
      }
    }
  };

  /**
   * Mapa de controladores de eventos que se aplicarán al informe integrado
   */
  public eventHandlersMap = new Map([
    [
      'loaded', () => {
        const report = this.reportObj.getReport();
        report.setComponentTitle('Embedded report');

        let reportContainer = document.getElementsByClassName('report-container')[0] as HTMLElement;
        reportContainer.style.height = '80vh';
      },
    ],
    [
      'error', (event?: service.ICustomEvent<any>) => {
        if (event) {
          console.error(event.detail);
        }
      },
    ]
  ]) as Map<string, (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null>;


  constructor(private powerBiService: PowerBiService, private loadManagerService: LoadManagerService) { }

  /**
   * Método de apertura de ventana modal
   * @param title Título a mostrar en la modal
   */
  public async openDialog(title: string): Promise<void> {

    this.errorPowerBi = '';

    this.dialog.title = title;

    this.loadManagerService.incLoadRequest();

    this.powerBiService.getReportAccessData().subscribe(response => {

      this.loadManagerService.decLoadRequest();

      this.dialog.open();

      if (response.embedUrl == '' || response.accessToken == '' || response.embedUrl == null || response.accessToken == null) {
        this.errorPowerBi = 'Se ha producido un error en la obtención de los informes';
      }
      else {
        // Configuración de la conexión con PowerBi
        this.reportConfig = {
          ...this.reportConfig,
          embedUrl: response.embedUrl,
          accessToken: response.accessToken
        };
      }

    }, error => {
      this.loadManagerService.decLoadRequest();
      this.errorPowerBi = 'Se ha producido un error en la obtención de los informes';
      console.error(error);
    });
  }

  /**
   * Método de cierre de ventana modal
   */
  public close(): void {
    this.dialog.close(null);
  }
}
